import { DevTools } from 'jotai-devtools'

export const JotaiDevToolsProvider = () => {
  return (
    <>
      <DevTools />
    </>
  )
}
